import { fetchWithRetry } from "./helpers/fetch-with-retry";

let inflight = null;

/**
 * The create modals all mount together on each scheduling
 * page, so concurrent callers share one request
 * @returns {Promise<Array>}
 */
export function fetchMembershipPlans() {
  if (inflight) return inflight;
  inflight = fetchWithRetry("/actions/coach-settings/membership-plans", {
    credentials: "same-origin",
  })
    .then((res) => (res.ok ? res.json() : []))
    .then((data) => (Array.isArray(data) ? data : []))
    .catch(() => [])
    .finally(() => {
      inflight = null;
    });
  return inflight;
}
